
import { useState, useEffect, useRef } from 'react';
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/contact/HeroSection";
import ContactSection from "@/components/contact/ContactSection";
import MapSection from "@/components/contact/MapSection";
import FAQSection from "@/components/contact/FAQSection";

const ContactUs = () => {
  // Always start with animations not visible
  const [heroVisible, setHeroVisible] = useState(false);
  const [contactVisible, setContactVisible] = useState(false);
  
  // Ref for the contact section
  const contactRef = useRef<HTMLElement>(null);
  
  useEffect(() => {
    // Show hero section immediately on every mount
    setHeroVisible(true);
    
    // Simple IntersectionObserver for contact section
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setContactVisible(true);
            // Once visible, unobserve to prevent retriggering
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    
    // Only observe if ref is available
    if (contactRef.current) {
      observer.observe(contactRef.current);
    }
    
    // Clean up on unmount
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1">
        <HeroSection isVisible={heroVisible} />
        
        <section ref={contactRef}>
          <ContactSection isVisible={contactVisible} />
        </section>
        
        <MapSection />
        
        <FAQSection />
      </main>
      
      <Footer />
    </div>
  );
};

export default ContactUs;
